import Vue from 'vue'
import VueRouter from 'vue-router'

import { notification } from 'ant-design-vue'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import store from '@/store'

// 解决相同路径跳转报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) { return originalPush.call(this, location, onResolve, onReject) }
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

export const resetRouter = (router, routes) => {
  const newRouter = createRouter(routes)
  router.matcher = newRouter.matcher
  router.options.routes = newRouter.options.routes
}

// console.log(process.env.BASE_URL)
export const createRouter = routes => {
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes
  })

  const { userStore, enumsStore } = store.state

  router.beforeEach(async (to, from, next) => {
    // 跳转页面时显示进度条
    NProgress.start()
    // userStore.userInfo = {}
    if (userStore.userInfo) { // 若已登录
      // 打开页面时，判断打开页面是否过多
      if (alivePagesIsOver(to.name, 20)) {
        NProgress.done()
        return
      }

      // // 检查是否存在路由表
      // if (!userStore.userRoutes) {
      //   // Vuex 设置登录用户的页面路由
      //   store.commit('setUserRoutes')
      //   resetRouter(router, userStore.userRoutes)
      // }

      // store 没有系统枚举数据 且 导航至非登录页时，则请求
      if (!enumsStore.enumsData && to.path !== '/login') {
        await store.dispatch('getEnumsData')
      }

      next()
    } else if (to.path !== '/login') { // 若未登录且导航其他页面，则跳转登录页
      next({ path: '/login' })
    } else { // 若未登录且导航登录页面，则直接跳转
      next()
    }
  })

  router.afterEach((to, from, failure) => {
    const { path: toPath } = to
    const { path: fromPath } = from
    // 当退出登录返回登录页时，清除 store 数据
    if (toPath === '/login' && fromPath !== '/' && fromPath !== '/login') {
      store.commit('emptyUser')
      store.commit('emptyEnums')
      store.commit('emptyAliveComponents')
    }

    NProgress.done()
  })
  return router
}

// 限制可打开的标签页个数，以确保性能消耗不会太大
function alivePagesIsOver(pageName, limit) {
  const { multTabStore } = store.state
  const openPages = multTabStore.aliveComponents.filter(page => page !== 'RouteView')
  // 跳转以打开的页面
  if (openPages.includes(pageName)) return false
  // 跳转未打开的页面时，检查 alive 的数量
  if (openPages.length >= limit) {
    notification.warning({
      message: `最多可打开 ${limit} 个标签页！`,
      description: '请关闭部分标签页后在操作。'
    })
    return true
  } else {
    return false
  }
}
